import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  MenuItem,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DescriptionIcon from "@mui/icons-material/Description";
import ItemRequest_Breadcrumbs from "./ItemRequest_Breadcrumbs";
import "./ItemRequest.css";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  ITEMSREQDeleteAPI,
  ITEMSREQLoadAPI,
  ITEMSREQPostAPI,
  ITEMSREQSaveAPI,
  sDetailGridColumn,
} from "./ItemCreationRequestAction";
import { ItemDetails } from "./component/ItemDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fcovertToNumber,
  fKeyTabInput,
} from "../../Utility/Utilitys";
import { Head_Set, Head_Set_Init } from "./SliceItemCreationRequest";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ItemCreationRequestRo } from "../../Redux/roStore";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { exportToExcel } from "../ItemApprove/ItemApproveRequestAction";

const ItemCreationRequest = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const aMediaQuery = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vRdxTax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);

  const LocWithoutRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const headObj = useSelector(
    (state) => state.SliceItemCreationRequest.value.Head
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const [detailGridData, setDetailGridData] = useState([]);
  const errorHeadInit = {
    A_Id: "",
    A_Date: "",
    A_Loc: "",
    A_Narr: "",
  };
  const [error, setError] = useState(errorHeadInit);

  const ErrorInit = {
    srNo: "",
    barCode: "",
    itemName: "",
    arabicName: "",
    subCategoryCode: "",
    subCategory: "",
    mainGroupCode: "",
    mainCategory: "",
    categoryCode: "",
    category: "",
    packing: "",
    brandCode: "",
    brand: "",
    vendorCode: "",
    vendor: "",
    taxDept: "",
    taxPerc: "",
    costPrice: "",
    rsp: "",
    rspVat: "",
  };
  const [detailError, setDetailError] = useState(ErrorInit);

  let initState = {
    srNo: 0,
    barCode: "",
    itemName: "",
    arabicName: "",
    subCategoryCode: "",
    subCategory: "",
    mainGroupCode: "",
    mainCategory: "",
    categoryCode: "",
    category: "",
    packing: "",
    brandCode: "",
    brand: "",
    vendorCode: "",
    vendor: "",
    taxDept: vRdxTax1[0].UId,
    taxPerc: vRdxTax1[0].Perc,
    costPrice: 0,
    rsp: 0,
    rspVat: 0,
    rejectNarr: "",
    rejectionReason: "",
  };
  const [detailData, setDetailData] = useState(initState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      Head_Set({
        ...headObj,
        [name]: value, // Dynamically update the field
      })
    );
  };

  const calculation = (taxPerc, rsp) => {
    const rspNum = fcovertToNumber(rsp);
    const taxPercNum = fcovertToNumber(taxPerc);
    const proRSPVAT = rspNum + (taxPercNum / 100) * rspNum;

    setDetailData((prevOrder) => ({
      ...prevOrder,
      rsp: rspNum,
      rspVat: proRSPVAT.toFixed(2),
    }));
  };

  const calculateRspVat = (taxPerc, rspVAT) => {
    const rspVATNum = fcovertToNumber(rspVAT);
    const taxPercNum = fcovertToNumber(taxPerc);

    const promoRSPVAT =
      taxPercNum === -100 ? 0 : (rspVATNum / (100 + taxPercNum)) * 100;

    setDetailData((prevOrder) => ({
      ...prevOrder,
      rspVat: rspVATNum,
      rsp: promoRSPVAT.toFixed(4),
    }));
  };

  const handleDetailChange = (e) => {
    const { name, value } = e.target;

    // Check if the changed field is "taxDept"
    if (name === "taxDept") {
      const selectedTax = vRdxTax1.find((tax) => tax.UId === value); // Find the selected tax data
      const taxPercValue = selectedTax ? selectedTax.Perc : 0; // Default to 0 if not found

      setDetailData((prevState) => ({
        ...prevState,
        [name]: value,
        taxPerc: taxPercValue, // Update taxPerc when taxDept changes
      }));
      calculation(taxPercValue, detailData.rsp);

      setTimeout(() => {
        document.getElementsByName("costPrice")[0]?.focus();
      }, 400);
      setDetailError((prevError) => ({
        ...prevError,
        [name]: value ? "" : prevError[name],
      }));
    } else {
      setDetailData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setDetailError((prevError) => ({
        ...prevError,
        [name]: value ? "" : prevError[name],
      }));
    }
  };
  const handleDetailRSPChange = (e) => {
    const { name, value } = e.target;
    setDetailData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    calculation(detailData.taxPerc, value);
    setDetailError((prevError) => ({
      ...prevError,
      [name]: value ? "" : prevError[name],
    }));
  };

  const handleDetailVATRSPChange = (e) => {
    const { name, value } = e.target;

    setDetailData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    calculateRspVat(detailData.taxPerc, value);
    setDetailError((prevError) => ({
      ...prevError,
      [name]: value ? "" : prevError[name],
    }));
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setDetailData((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setDetailData((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };

  const fValidationHead = () => {
    let isValid = true;

    const newError = {
      A_Id: "",
      A_Date: "",
      A_Loc: "",
      A_Narr: "",
    };

    if (
      headObj?.A_Id === "" ||
      headObj?.A_Id == undefined ||
      headObj?.A_Id === null
    ) {
      newError.A_Id = "TransId is required.";
      isValid = false;
    }
    if (
      !headObj?.A_Date ||
      headObj?.A_Date == undefined ||
      headObj?.A_Date === null ||
      headObj?.A_Date === "Invalid date"
    ) {
      newError.A_Date = "Date is required.";
      isValid = false;
    }
    if (
      headObj?.A_Loc == "" ||
      headObj?.A_Loc == undefined ||
      headObj?.A_Loc === null
    ) {
      newError.A_Loc = "Location is required.";
      isValid = false;
    }

    setError((prevError) => ({
      ...prevError,
      ...newError,
    }));

    if (!isValid) {
      const firstInvalidField = Object.keys(newError).find(
        (key) => newError[key]
      );
      document.querySelector(`[name="${firstInvalidField}"]`)?.focus();
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    const newError = {
      itemName: "",
      arabicName: "",
      subCategory: "",
      mainCategory: "",
      category: "",
      packing: "",
      brand: "",
      vendor: "",
    };
    if (
      detailData?.srNo === "" ||
      detailData?.srNo == undefined ||
      detailData?.srNo === null
    ) {
      newError.srNo = "Item Name is required.";
      isValid = false;
    }
    if (
      detailData?.barCode === "" ||
      detailData?.barCode == undefined ||
      detailData?.barCode === null
    ) {
      newError.barCode = "BarCode is required.";
      isValid = false;
    }
    if (
      detailData?.itemName === "" ||
      detailData?.itemName == undefined ||
      detailData?.itemName === null
    ) {
      newError.itemName = "Item Name is required.";
      isValid = false;
    }
    if (
      detailData?.arabicName === "" ||
      detailData?.arabicName == undefined ||
      detailData?.arabicName === null
    ) {
      newError.arabicName = "Arabic Name is required.";
      isValid = false;
    }
    if (
      detailData?.itemName === "" ||
      detailData?.itemName == undefined ||
      detailData?.itemName === null
    ) {
      newError.category = "Category is required.";
      isValid = false;
    }
    if (
      detailData?.categoryCode === "" ||
      detailData?.categoryCode == undefined ||
      detailData?.categoryCode === null
    ) {
      newError.category = "Category code is required.";
      isValid = false;
    }
    if (
      detailData?.subCategory === "" ||
      detailData?.subCategory == undefined ||
      detailData?.subCategory === null
    ) {
      newError.subCategory = "Sub-Category is required.";
      isValid = false;
    }
    if (
      detailData?.subCategoryCode === "" ||
      detailData?.subCategoryCode == undefined ||
      detailData?.subCategoryCode === null
    ) {
      newError.subCategory = "Sub-Category code is required.";
      isValid = false;
    }
    if (
      detailData?.mainCategory === "" ||
      detailData?.mainCategory == undefined ||
      detailData?.mainCategory === null
    ) {
      newError.mainCategory = "Main Category is required.";
      isValid = false;
    }
    if (
      detailData?.mainGroupCode === "" ||
      detailData?.mainGroupCode == undefined ||
      detailData?.mainGroupCode === null
    ) {
      newError.mainCategory = "Main Category code is required.";
      isValid = false;
    }
    if (
      detailData?.packing === "" ||
      detailData?.packing == undefined ||
      detailData?.packing === null
    ) {
      newError.packing = "Packing is required.";
      isValid = false;
    }
    if (
      detailData?.brandCode === "" ||
      detailData?.brandCode == undefined ||
      detailData?.brandCode === null
    ) {
      newError.brand = "Brand code is required.";
      isValid = false;
    }
    if (
      detailData?.brand === "" ||
      detailData?.brand == undefined ||
      detailData?.brand === null
    ) {
      newError.brand = "Brand is required.";
      isValid = false;
    }
    if (
      detailData?.vendor === "" ||
      detailData?.vendor == undefined ||
      detailData?.vendor === null
    ) {
      newError.vendor = "Vendor is required.";
      isValid = false;
    }
    if (
      detailData?.vendorCode === "" ||
      detailData?.vendorCode == undefined ||
      detailData?.vendorCode === null
    ) {
      newError.vendor = "Vendor code is required.";
      isValid = false;
    }
    if (
      detailData?.taxDept === "" ||
      detailData?.taxDept == undefined ||
      detailData?.taxDept === null
    ) {
      newError.taxDept = "Tax Dept is required.";
      isValid = false;
    }
    if (
      detailData?.costPrice === "" ||
      detailData?.costPrice == undefined ||
      detailData?.costPrice === null ||
      detailData?.costPrice == 0
    ) {
      newError.costPrice =
        detailData?.costPrice == 0
          ? "Cost Price should not be zero."
          : "Cost Price is required.";
      isValid = false;
    }
    if (
      detailData?.rsp === "" ||
      detailData?.rsp == undefined ||
      detailData?.rsp === null ||
      detailData?.rsp == 0
    ) {
      newError.rsp =
        detailData?.rsp == 0 ? "RSP should not be zero." : "RSP is required.";
      isValid = false;
    }
    if (
      detailData?.rspVat === "" ||
      detailData?.rspVat == undefined ||
      detailData?.rspVat === null ||
      detailData?.rspVat == 0
    ) {
      newError.rspVat =
        detailData?.rspVat == 0
          ? "VAT RSP should not be zero."
          : "VAT RSP is required.";
      isValid = false;
    }

    // Update the error state
    setDetailError((prevError) => ({
      ...prevError,
      ...newError,
    }));

    // Focus on the first invalid field
    if (!isValid) {
      document.getElementById("barCode")?.focus();
    }

    return isValid;
  };

  const fNewHead = () => {
    dispatch(Head_Set_Init());
    let { Head } = ItemCreationRequestRo();
    dispatch(
      Head_Set({
        ...Head,
        A_Loc: LocWithoutRights[0]?.Uid,
        A_LocName: LocWithoutRights[0]?.Name1,
      })
    );
    setError(errorHeadInit);
    fNewDetail(); // Trigger fNewDetail after setting Head values
    setTimeout(() => {
      document.getElementById("transDate")?.focus();
    }, 1000);
  };

  // Function to initialize detailData, load grid, and focus on Barcode
  const fNewDetail = () => {
    setDetailData(initState);
    setDetailError(ErrorInit);
    calculation(vRdxTax1[0].Perc, 0);
    fLoadGrid(); // Load grid data
  };

  const fNew = () => {
    if (detailData.barCode === "") {
      fNewHead(); // Call fNewHead if barcode is empty
    } else {
      fNewDetail(); // Otherwise, call fNewDetail
    }
  };

  const fLoadGrid = async () => {
    let { Head } = ItemCreationRequestRo();
    const Obj = {
      Id: Head?.A_Id,
    };

    let response = await ITEMSREQLoadAPI(
      fcheck_null_undefine_replace_empty(Obj)
    );

    if (response?.status === 200 && response?.data?.ResultSet?.length > 0) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setDetailGridData(GridID);
    } else {
      setDetailGridData([]);
    }
    if (detailData.barCode === "") {
      setTimeout(() => {
        document.getElementById("transDate")?.focus();
      }, 1000);
    } else {
      setTimeout(() => {
        document.getElementById("barCode")?.focus();
      }, 100);
    }
  };

  const fApprove = async () => {
    setDetailError(ErrorInit);
    setError(errorHeadInit);
    let validation = fValidationHead();
    if (!validation) return;

    if (detailData.barCode != "") {
      fAlertToast("FAILED", "Please save current line item before approve");
      return;
    }

    if (detailGridData.length == 0) {
      fAlertToast("INFO", "Add atleast one line item");
      return;
    }
    confirmAlert({
      title: "Approve",
      message: "Are you want to Approve?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            let { Head } = ItemCreationRequestRo();
            const Obj = {
              P_A_Id: parseInt(Head?.A_Id),
              P_UserCd: vRdxuserInfo.UserID,
            };

            let response = await ITEMSREQPostAPI(
              fcheck_null_undefine_replace_empty(Obj)
            );

            if (response?.status === 200) {
              fAlertToast("SUCCESS", "Successfully posted");
              dispatch(
                Head_Set({
                  ...headObj,
                  A_Status: "POST",
                })
              );
              navigate("/ItemRequestSummary");
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const fSave = () => {
    if (
      headObj?.A_Status !== "ENTER" &&
      headObj?.A_Confirm_Status !== "REJECT"
    ) {
      fAlertToast(
        "FAILED",
        `Document status should be "Enter" (Current: ${headObj?.A_Status})`
      );
      return;
    }

    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;
    const isDetailValid = fValidationDetail();
    if (!isDetailValid) return;

    confirmAlert({
      title: "Save",
      message: "Are you sure you want to save?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fSaveItem(); // Call the save function on confirmation
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {
            fAlertToast("INFO", "Save operation canceled.");
          },
        },
      ],
    });
  };

  const fSaveItem = async () => {
    let { Head } = ItemCreationRequestRo();
    const Obj = {
      P_A_Id: Head?.A_Id,
      P_A_Loc: Head?.A_Loc === "" ? LocWithoutRights[0]?.Uid : Head?.A_Loc,
      P_A_Narr: Head?.A_Narr,
      P_B_ItemName: detailData?.itemName,
      P_B_ItemNameFL: detailData?.arabicName,
      P_B_Barcode: detailData?.barCode,
      P_B_Category: detailData?.categoryCode,
      P_B_SubCategory: detailData?.subCategoryCode,
      P_B_MainCategory: detailData?.mainGroupCode,
      P_B_Packing: detailData?.packing,
      P_B_Brand: detailData?.brandCode,
      P_B_Vendor: detailData?.vendorCode,
      P_B_CostPr: detailData?.costPrice,
      P_B_RSP: detailData?.rsp,
      P_B_Tax_dept: detailData?.taxDept,
      P_B_Tax_perc: detailData?.taxPerc,
      P_B_Vat_RSP: detailData?.rspVat,
      P_UserCd: vRdxuserInfo.UserID,
    };
    let response = await ITEMSREQSaveAPI(
      fcheck_null_undefine_replace_empty(Obj)
    );

    if (response?.status === 200) {
      const savedHead = response?.data?.data?.[0];
      if (savedHead) {
        dispatch(
          Head_Set({
            ...headObj,
            A_Id: savedHead.A_Id,
          })
        );
      }
      fAlertToast("SUCCESS", "Successfully Saved");
      fNewDetail();
      setError(errorHeadInit);
    }
  };

  const fDeleteTrans = async () => {
    let { Head } = ItemCreationRequestRo();
    const Obj = {
      P_B_Id: Head?.A_Id,
      P_B_Barcode: detailData?.barCode,
      P_UserCd: vRdxuserInfo.UserID,
    };
    let response = await ITEMSREQDeleteAPI(
      fcheck_null_undefine_replace_empty(Obj)
    );

    if (response?.status === 200) {
      if (detailData?.barCode === "") {
        dispatch(
          Head_Set({
            ...headObj,
            A_Status: "DELETE",
          })
        );
      }
      fAlertToast(
        "SUCCESS",
        detailData?.barCode === ""
          ? "Transaction deleted successfully"
          : "Line item deleted successfully"
      );
      fNewDetail();
      setError(errorHeadInit);
      detailData?.barCode === ""
        ? navigate("/ItemRequestSummary")
        : navigate("/ItemCreationRequest");
    }
  };

  const fDelete = () => {
    if (
      headObj?.A_Status === "POST" &&
      headObj?.A_Confirm_Status !== "REJECT"
    ) {
      fAlertToast("FAILED", "You are not allowed to delete in post status.");
      return;
    } else {
      // Confirm alert for head delete
      confirmAlert({
        title: "Delete",
        message:
          detailData?.barCode === ""
            ? "Are you sure you want to delete the Transaction?"
            : "Are you sure you want to delete this line item?",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteTrans();
            },
          },
          {
            className: "alertBtn",
            label: "No",
          },
        ],
      });
    }
  };

  const fExport = () => {
    exportToExcel(detailGridData, "ItemRequest_data", "ItemRequest");
  };

  useEffect(() => {
    fLoadGrid();
    calculation(vRdxTax1[0].Perc, 0);
  }, []);

  return (
    <div className="my-2">
      <div className="Breadcrumbs d-flex">
        <ItemRequest_Breadcrumbs />
      </div>
      <div className="ItemRequest-detailhead">
        <Box
          className="ItemRequest-headInfo"
          sx={{
            paddingX: vMediaQuery ? "8px" : aMediaQuery ? 2 : 4,
            paddingY: aMediaQuery ? 1 : 1.5,
            borderRadius: 3,
            boxShadow: 1,
            backgroundColor: "#f9f9f96e",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="h6"
              sx={{
                color: "#424242",
                marginBottom: 0.5,
                textDecoration: "underline",
              }}
            >
              Header Information
            </Typography>
          </div>
          <Grid
            container
            spacing={{ xs: 1, sm: 1, md: 2 }}
            padding={vMediaQuery ? 0 : 1}
            marginTop={0}
          >
            <Grid item xs={5} sm={1.5} md={2}>
              <TextField
                fullWidth
                label="Trans ID"
                variant="outlined"
                name="A_Id"
                value={headObj?.A_Id}
                onChange={handleChange}
                disabled={true}
                inputProps={{ readOnly: true }}
                error={!!error.A_Id}
                helperText={error.A_Id}
              />
            </Grid>
            <Grid item xs={7} sm={2.3} md={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  inputProps={{
                    tabIndex: 1,
                  }}
                  label="Trans Date"
                  name="A_Date"
                  value={headObj?.A_Date}
                  onChange={(newValue) =>
                    dispatch(
                      Head_Set({
                        ...headObj,
                        A_Date: newValue.$d, // Extract the native date object
                      })
                    )
                  }
                  onKeyUp={(e) => {
                    fKeyTabInput(e, "A_Loc");
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      id="transDate"
                      error={!!error.A_Date}
                      helperText={error.A_Date}
                    />
                  )}
                  disabled={detailGridData?.length > 0}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                inputProps={{
                  tabIndex: 2,
                }}
                onKeyUp={(e) => {
                  fKeyTabInput(e, "A_Narr");
                }}
                select
                fullWidth
                label="Location"
                variant="outlined"
                autoComplete="off"
                name="A_Loc"
                value={
                  headObj?.A_Loc === ""
                    ? LocWithoutRights[0]?.Uid
                    : headObj?.A_Loc
                }
                onChange={handleChange}
                InputProps={{
                  startAdornment: <LocationOnIcon sx={{ marginRight: 1 }} />,
                }}
                error={!!error.A_Loc}
                helperText={error.A_Loc}
                disabled={detailGridData?.length > 0}
                // onChange={handleLocationChange}
              >
                {LocWithoutRights?.map((typ) => (
                  <MenuItem key={typ.Uid} value={typ.Uid}>
                    {typ.Name1}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={5.2} md={5}>
              <TextField
                inputProps={{
                  tabIndex: 101,
                }}
                fullWidth
                label="Narration"
                variant="outlined"
                name="A_Narr"
                autoComplete="off"
                value={headObj?.A_Narr}
                onChange={handleChange}
                // multiline
                InputProps={{
                  startAdornment: <DescriptionIcon sx={{ marginRight: 1 }} />,
                }}
                error={!!error.A_Narr}
                helperText={error.A_Narr}
                disabled={detailGridData?.length > 0}
              />
            </Grid>
          </Grid>

          {/* Detail Section */}
          <Card
            sx={{
              borderRadius: 4,
              boxShadow: 0,
              marginTop: aMediaQuery ? 1 : 0,
              // "&.MuiCard-root": {
              //   border: "1px solid #e5e2e2",
              // },
              "& .MuiCardContent-root": {
                padding: "4px !important",
              },
            }}
          >
            <CardContent>
              <Grid container spacing={0}>
                <Grid item xs={12} sm={2.7} md={2.5} lg={1.5}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#424242",
                      marginBottom: vMediaQuery ? 0 : 0.5,
                      textDecoration: "underline",
                    }}
                  >
                    Item Details
                  </Typography>
                </Grid>
                {detailData?.rejectionReason != "" && (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      md={5}
                      lg={5.5}
                      sx={{ color: "red" }}
                    >
                      <Typography marginTop={"6px"}>
                        Narration : <strong>{detailData?.rejectNarr}</strong>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4.5}
                      md={4.5}
                      lg={5}
                      sx={{ color: "red" }}
                    >
                      <Typography marginTop={"6px"}>
                        Rejection :{" "}
                        <strong> {detailData?.rejectionReason}</strong>
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>

              <ItemDetails
                aMediaQuery={aMediaQuery}
                vMediaQuery={vMediaQuery}
                detailData={detailData}
                vRdxTax1={vRdxTax1}
                setDetailData={setDetailData}
                handleDetailChange={handleDetailChange}
                headObj={headObj}
                detailError={detailError}
                fNew={fNew}
                fSave={fSave}
                fApprove={fApprove}
                fDelete={fDelete}
                fContent_Blur={fContent_Blur}
                fContent_Focus={fContent_Focus}
                fExport={fExport}
                handleDetailRSPChange={handleDetailRSPChange}
                handleDetailVATRSPChange={handleDetailVATRSPChange}
              />

              <div className={vMediaQuery ? "pt-2 px-0" : "py-2 px-3"}>
                <Box style={{ height: "40vh", width: "100%" }}>
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    height={20}
                    getRowId={(row) => row.id}
                    rows={detailGridData}
                    columns={sDetailGridColumn}
                    experimentalFeatures={{ newEditingApi: false }}
                    hideFooter={detailGridData.length < 100}
                    onRowClick={(rowData) => {
                      console.log(rowData.row);
                      setDetailData((obj) => ({
                        ...obj,
                        srNo: rowData.row.B_Id || 0,
                        barCode: rowData.row.B_Barcode || "",
                        itemName: rowData.row.B_ItemName || "",
                        arabicName: rowData.row.B_ItemNameFL || "",
                        subCategoryCode: rowData.row.B_SubCategory || "",
                        subCategory: rowData.row.SubCategoryName || "",
                        mainGroupCode: rowData.row.B_MainCategory || "",
                        mainCategory: rowData.row.MainCategoryName || "",
                        categoryCode: rowData.row.B_Category || "",
                        category: rowData.row.CategoryName || "",
                        packing: rowData.row.B_Packing || "",
                        brandCode: rowData.row.B_Brand || "",
                        brand: rowData.row.BrandName || "",
                        vendorCode: rowData.row.B_Vendor || "",
                        vendor: rowData.row.VendorName || "",
                        taxDept: rowData.row.B_Tax_dept || "",
                        taxPerc: rowData.row.B_Tax_perc || 0,
                        costPrice: rowData.row.B_CostPr || 0,
                        rsp: rowData.row.B_RSP || 0,
                        rspVat: rowData.row.B_Vat_RSP || 0,
                        rejectNarr: rowData.row.B_Narration || 0,
                        rejectionReason:
                          rowData.row.B_Rejection_reasonName || 0,
                      }));
                    }}
                    components={{
                      Toolbar: true ? "" : GridToolbar,
                    }}
                  />
                </Box>
              </div>
            </CardContent>
          </Card>
          {/* Footer Section */}
        </Box>
      </div>
    </div>
  );
};

export default ItemCreationRequest;
